import * as React from 'react';
import { observer, inject } from 'mobx-react';
import './confirmationPane.module.scss';
import { Pane, PaneBody, PaneBackButton, Page, ContextAwarePaneHeader } from '../../atoms/applications/page';
import { Loader } from '../../atoms/forms/loader';
import { ButtonWrapper, SubmitButton } from '../../atoms/forms/vertical/base';
import { observable, makeObservable } from 'mobx';
import {
  SummaryBody,
  SummaryHeader,
  SummaryStartDateRow,
  SummaryTotalPriceRow,
} from '../../molecules/applications/base';
import { CardSummary } from '../../molecules/payment/CardInput';
import { EntranceFeeSummary } from '../../molecules/applications/EntranceFeeSummary';
import { MembershipItemDetailedSummary } from '../../molecules/applications/MembershipItemDetailedSummary';
import { ApplicationErrorSummary } from '../../molecules/applications/ApplicationErrorSummary';
import { ServiceAgreementPane } from '../service_agreements/ServiceAgreementPane';
import { BaseApplicationPageState } from '../../../containers/application/states/BaseApplicationPageState';
import { UserAddressSummary } from '../../../components/molecules/applications/UserAddressForm';

export const LegacyServiceAgreementPane = observer(({ agreed, onAgreeStatusChange }) => {
  return (
    <div styleName="agreement">
      <input id="agreed" type="checkbox" checked={agreed} onChange={onAgreeStatusChange} />
      <label htmlFor="agreed">
        <a href="https://she-inc.jp/common/agreement.html" target="_blank">
          利用規約
        </a>
        に同意して申し込む
      </label>
    </div>
  );
});

export const ServiceAgreementPaneSwitch = ({ serviceAgreementState, agreedOfLegacy, onCheckOfLegacy }) => {
  if (serviceAgreementState.serviceAgreement) {
    return <ServiceAgreementPane paneState={serviceAgreementState} />;
  } else {
    return <LegacyServiceAgreementPane agreed={agreedOfLegacy} onAgreeStatusChange={onCheckOfLegacy} />;
  }
};

type Props = {
  applicationState: BaseApplicationPageState;
};

export const ApplicationConfirmationPane = inject('applicationState')(
  observer(
    class ApplicationConfirmationPane extends React.Component<Props> {
      agreed = false;

      constructor(props: Props) {
        super(props);

        makeObservable(this, {
          agreed: observable,
        });
      }

      onCheck(checked: boolean) {
        this.agreed = checked;
      }

      render() {
        const {
          applicationState: {
            canGoBack,
            applicationPage,
            applicationPageResource,
            entranceInstallments,
            serviceAgreementState,
            addressFormState,
            cardState,
            submit,
            totalPrice,
            error,
            name,
            entranceFeeItemName,
            startDate,
            submitState: { submitting },
          },
        } = this.props;
        if (applicationPageResource.loading) {
          return <Loader />;
        }

        const showNewAgreement = !!serviceAgreementState.serviceAgreement;
        const allAgreed = showNewAgreement ? serviceAgreementState.isAllAgreed : this.agreed;
        return (
          <Page>
            <Pane>
              {canGoBack && <PaneBackButton />}
              <ContextAwarePaneHeader planName={name}>お申し込み内容の確認</ContextAwarePaneHeader>
              <PaneBody>
                <SummaryHeader>住所</SummaryHeader>
                <SummaryBody>
                  <UserAddressSummary userAddress={addressFormState.getDirtyValue()} />
                </SummaryBody>
                {applicationPage.membership_item.price > 0 && (
                  <>
                    <SummaryHeader>プラン内容</SummaryHeader>
                    <MembershipItemDetailedSummary item={applicationPage.membership_item} />
                  </>
                )}
                {applicationPage.entrance_fee_item && (
                  <EntranceFeeSummary
                    title={entranceFeeItemName}
                    entranceFee={applicationPage.entrance_fee_item}
                    installments={entranceInstallments}
                  />
                )}
                <SummaryHeader>お支払い方法</SummaryHeader>
                <SummaryBody>
                  <CardSummary styleName="card-summary" card={cardState.card} />
                </SummaryBody>
                <SummaryTotalPriceRow label="お支払い金額" price={totalPrice} unit={'円（税込）'} />
                <SummaryStartDateRow startDate={startDate} textSize="s" />
                <ServiceAgreementPaneSwitch
                  serviceAgreementState={serviceAgreementState}
                  agreedOfLegacy={this.agreed}
                  onCheckOfLegacy={() => this.onCheck(!this.agreed)}
                />
                {error && (
                  <ApplicationErrorSummary title="お申し込みを確定することができませんでした。" type="normal">
                    考えられる要因
                    <br />
                    ・クレジットカードの限度額
                    <br />
                    ・引き落とし先の銀行口座の残高不足
                    <br />
                    など
                  </ApplicationErrorSummary>
                )}
                <ButtonWrapper>
                  <SubmitButton id="application-submit" loading={submitting} disabled={!allAgreed} onClick={submit}>
                    お申し込みを確定する
                  </SubmitButton>
                </ButtonWrapper>
              </PaneBody>
            </Pane>
          </Page>
        );
      }
    }
  )
);
